import React from "react";

import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";

export const ScoreView: React.FC<{
  score: number;
  scoreNormalised: number;
}> = ({ score, scoreNormalised }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" value={scoreNormalised} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {Math.round(score)}
        </Typography>
      </Box>
    </Box>
  );
};

export const normaliseMEPScore = (value: number) =>
  ((value - 0) * 100) / (2881 - 0);
